<div *ngIf="chaseDetails != null">
  <member-chase-detail-chart [chaseDetailsForAudit]="chaseDetails" [enablePopUpBtn]="false"></member-chase-detail-chart>
</div>
